<template>
    <div v-if="settings" :class="'border-' + frame_color" class="card m-2" style="max-width: 700px;min-width: 700px">
        <div :class="'bg-' + frame_color" class="card-header d-flex flex-row justify-content-between navbar-height">
            <h2 class="flex-grow-1 text-white p-1">{{ $t(settings.title) }}</h2>
            <button v-if="show_history && !settings.is_edit"
                    class="btn text-light link"
                    data-bs-toggle="modal"
                    data-bs-target="#settings_history_modal">
                {{ $t('Settings History') }}
            </button>
            <div v-if="show_edit && !settings.is_edit && hasPermission(auth_user.can, 'update.device.settings') && isConnectedPatientAllowed">
                <DeviceEdit :mode="'Edit'" :patient_id="patient_id" :history_id="history_id" :edit_allowed="edit_allowed"/>
            </div>
        </div>
        <div class="card-body">
            <template v-if="settings.is_edit">
                <div class="text-end pb-2 pe-3">
                    <i>
                        {{ $t("Changes submitted") }} {{ createdBy }}
                        {{ $t("on") }}
                        {{ dateAndTime(settings.collected, DateFormat.LongDateWithOrdinal) }}
                        {{ $t("at") }}
                        {{ time(settings.collected) }}
                    </i>
                </div>
            </template>
            <template v-else-if="settings.status!='Defaults'">
                <div class="text-end pb-2 pe-3">
                    <i>
                        {{ $t("Collected via") }} {{ settings.source_display }}
                        {{ $t("on") }}
                        {{ dateAndTime(settings.collected, DateFormat.LongDateWithOrdinal) }}
                        {{ $t("at") }}
                        {{ time(settings.collected) }}
                    </i>
                </div>
            </template>
            <SettingsSection :title="$t('Therapy Settings')" :fields="settings.therapy" :compare_to="current.therapy" />
            <SettingsSection v-if="settings.comfort" :title="$t('Comfort Settings')" :fields="settings.comfort" :compare_to="current.comfort" />
            <SettingsSection v-if="settings.alerts" :title="$t('Alert Settings')" :fields="settings.alerts" :compare_to="current.alerts" />
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import SettingsSection from "./SettingsSection.vue";
import DeviceEdit from "./DeviceEdit.vue";
import {dateAndTime, time} from "../../../utilities/date";
import usePermissions from "@/vue/composables/usePermissions";
import { DateFormat } from "@/libs/dates/useDates";

const props = defineProps({
    user_org: {
        type: [Object, null],
        required: true,
    },
    patient_org: {
        type: Object,
        required: false,
    },
    settings: {
        type: [Object, null],
        required: true,
    },
    current: {
        type: Object,
        required: false,
        default: Object,
    },
    patient_id: {
        type: Number,
        required: true,
    },
    history_id: {
        type: Number,
        required: true,
    },
    show_history: {
        type: Boolean,
        default: false,
    },
    show_edit: {
        type: Boolean,
        default: false,
    },
    edit_allowed: {
        type: String,
        default: "",
        required: false
    },
    auth_user: {
        type: [Object, null],
        required: true
    }
});

const { hasPermission } = usePermissions();

const isConnectedPatientAllowed = computed(() => {
    let disallow_external_device_edit = props?.patient_org?.settings?.settings?.disallow_external_device_edit ?? false;
    if( disallow_external_device_edit === true && props.user_org?.id !== props.patient_org?.id ) {
        return false;
    }
    else {
        return true;
    }
});

const frame_color = computed(() => {
    if( props.settings && props.settings.is_edit ) {
        switch( props.settings.status ) {
        case 'Failed Delivery':
        case 'Void/Replaced':
            return 'danger';
        case 'Pending Delivery':
            return 'warning';
        default:
            return 'secondary';
        }
    }
    return 'primary';
});

const createdBy = computed(() => {
    if( props.settings && props.settings.submitted_by ) {
        return ' ' + $t('by') + ' ' + props.settings.submitted_by;
    }
    return '';
});
</script>
